<template>
  <component :is="layout">
    <div
      v-if="initializing"
      class="w-100 h-100 d-flex justify-content-center align-items-center"
    >
      <odd-spinner :size="48" />
    </div>
    <keep-alive
      v-else
      :include="['odd-view-products-main', 'odd-view-orders-main', 'odd-table']"
    >
      <router-view />
    </keep-alive>
  </component>
</template>

<script>
import Cookies from "js-cookie";

export default {
  data() {
    return {
      loading: true,
      authRetries: 0
    };
  },
  created() {
    this.initAuth();
  },
  methods: {
    initAuth(authRetries = 0) {
      this.$store.dispatch("auth/initAuth").then(() => {
        if (this.$store.getters["auth/authenticated"]) {
          this.$store.dispatch("settings/initPaymentProcessor");
          this.$store.dispatch("shop/initShopSettings");
          this.$store.dispatch("shop/initShopSettings");
          this.$store.dispatch("settings/initSettings");
          this.$store.dispatch("productCollections/init");
          this.$store.dispatch("productCategories/init");
          this.$router.push(this.$route.query.next || "/");
        }
      });
    }
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || "default"}-layout`;
    },
    initializing() {
      return this.$store.state.auth.initializing;
    }
  }
};
</script>

<style lang="scss">
.quill-editor {
  background: #fff;
}
.card-body-border {
  border: 2px solid rgba(0, 0, 0, 0.03);
  border-top-width: 0;
}
// Fix checkboxes/radios for vue-form-generator
input[type="radio"],
input[type="checkbox"] {
  width: 2rem;
}

.top-0 {
  top: 0;
}
.right-0 {
  right: 0;
}
.bottom-0 {
  bottom: 0;
}
.left-0 {
  left: 0;
}

.scroll-spy-list {
  .active {
    color: red;
  }
}

.radius-1 {
  border-radius: 0.1rem;
}

.radius-10 {
  border-radius: 1rem;
}

.active_button {
  background: green;
}

.inactive_button {
  background: white;
}

.text-line-through {
  text-decoration: line-through;
}
</style>
